import React from "react";

export default function Footer({ className = "" }) {
  return (
    <footer
      data-testid="app-footer"
      className={
        "w-full text-center text-[11px] sm:text-xs text-neutral-400 py-6 px-4 " +
        className
      }
    >
      © 2026 Natur Autoescuela · Desarrollado por Operador Digital Natur Commodities, S.L.
    </footer>
  );
}
